// extracted by mini-css-extract-plugin
export var editButton = "_ng-0";